import { put, call, takeEvery } from "redux-saga/effects";
import * as apis from "../../network/apis/evaluation";
import * as types from "./types";
import * as actions from "./actions";
import { ROUTE_PATHS } from "../../utils/RoutesPaths";
import history from "../../routes/History";
import { showErrorMsg, showSuccessMsg } from "../../utils/Helpers";

function* addEvaluationEventSaga({ payload }) {
  try {
    const response = yield call(apis.createEvaluation, payload);
    sessionStorage.setItem("zonesEventId", payload);
    history.push(ROUTE_PATHS.events, {
      evaluation_name: response.data.data.name,
    });
  } catch (err) {
    yield call(showErrorMsg, err.response?.data?.message);
  }
}
//Submit evaluation form
function* submitEvaluationFormSaga({ payload }) {
  try {
    const userType = localStorage.getItem("userType");
    yield call(
      userType === "admin" || userType === "visitor"
        ? apis.submitEvaluation
        : apis.submitSupervisorEvaluation,
      payload
    );
    yield call(showSuccessMsg, "addedSuccessfully");
    const { redirectionPath, evaluation_name } = payload;
    history.push(redirectionPath, { evaluation_name });
  } catch (err) {
    yield call(showErrorMsg, err.response?.data?.message);
  }
}

function* getViewFormDetails({ payload }) {
  try {
    const userType = localStorage.getItem("userType");
    const response = yield call(
      userType === "admin" || userType === "visitor"
        ? apis.getViewFormDetails
        : apis.getViewFormDetailsSupervisor,
      payload
    );

    yield put(actions.viewFormResponse(response.data.data));
  } catch (err) {
    yield call(showErrorMsg, err.response?.data?.message);
  }
}

function* getEvaluationListSaga({ payload }) {
  try {
    const response = yield call(apis.getEvaluation, payload);
    yield put(actions.getEvaluationsResponse(response.data.data));
  } catch (err) {
    yield call(showErrorMsg, err.response?.data?.message);
  }
}

function* updateEvaluationListSaga({ payload }) {
  try {
    const response = yield call(apis.updateEvaluation, payload);
    yield put(actions.getEvaluationsResponse(response.data.data));
    history.push(ROUTE_PATHS.events);
    yield call(showSuccessMsg, "Evaluation Updated Successfully !", true);
  } catch (err) {
    yield call(showErrorMsg, err.response?.data?.message);
  }
}

export default function* EvaluationsEventSagas() {
  yield takeEvery(types.ADD_EVALUATION_EVENT_REQUEST, addEvaluationEventSaga);
  yield takeEvery(
    types.SUBMIT_EVALUATION_EVENT_REQUEST,
    submitEvaluationFormSaga
  );
  yield takeEvery(types.VIEW_FORM_REQUEST, getViewFormDetails);
  yield takeEvery(types.GET_EVALUATION_REQUEST, getEvaluationListSaga);
  yield takeEvery(types.UPDATE_EVALUATION_REQUEST, updateEvaluationListSaga);
}
